var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 52,
    viewBox: "0 0 200 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_487",
    "data-name": "Grupo 487",
    transform: "translate(-745 -804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_2",
    "data-name": "Ret\\xE2ngulo 2",
    d: "M0,0H147a2,2,0,0,1,2,2V50a2,2,0,0,1-2,2H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(796 804)",
    fill: "#d0bd5b"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Upload_foto",
    "data-name": "Upload foto",
    transform: "translate(870 838)",
    fill: "#8e1537",
    fontSize: 22,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -62.187,
    y: 0
  }, "Upload foto")), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_4",
    "data-name": "Ret\\xE2ngulo 4",
    d: "M2,0H51a0,0,0,0,1,0,0V52a0,0,0,0,1,0,0H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    transform: "translate(745 804)",
    fill: "#8e1537"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_icons",
    transform: "translate(753.826 813.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(4 4.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M9.693,13.016l3.644-3.644v12.04A1.5,1.5,0,0,0,14.921,23a1.5,1.5,0,0,0,1.584-1.584V9.372l3.644,3.644a1.531,1.531,0,0,0,2.218,0,1.531,1.531,0,0,0,0-2.218L16.03,4.461c-.158-.158-.317-.317-.475-.317a1.735,1.735,0,0,0-1.267,0c-.158.158-.317.158-.475.317L7.475,10.8a1.568,1.568,0,1,0,2.218,2.218Z",
    transform: "translate(-2.247 -4.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M27.764,13a1.5,1.5,0,0,0-1.584,1.584v3.168a3.178,3.178,0,0,1-3.168,3.168H10.337a3.178,3.178,0,0,1-3.168-3.168V14.584A1.5,1.5,0,0,0,5.584,13,1.5,1.5,0,0,0,4,14.584v3.168a6.356,6.356,0,0,0,6.337,6.337H23.011a6.356,6.356,0,0,0,6.337-6.337V14.584A1.5,1.5,0,0,0,27.764,13Z",
    transform: "translate(-4 1.219)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonUpload);
export default __webpack_public_path__ + "static/media/buttonUpload.a304d93062a9cf25ef2ad74872143fc1.svg";
export { ForwardRef as ReactComponent };